import { z } from "zod";
import { postcodeRegex } from "./utils";
import parsePhoneNumber from "libphonenumber-js";

export const postcode = z
  .string()
  .min(1)
  .transform((value) => value.split(" ").join(""))
  .refine(
    (value) => postcodeRegex.test(value),
    "common.form.errors.invalidPostcode",
  );

export const phoneNumber = z
  .string()
  .refine(
    (value) =>
      value === "" ||
      /^(?:0|\+?44)\s?(?:\(0\)){0,1}\s?(?:\d\s?){9,10}$/.test(value),
    "common.form.errors.invalidNumber",
  );

export const validPhoneNumber = z
  .string()
  .min(1, { message: "Phone number is required" })
  .refine((val) => parsePhoneNumber(val)?.isValid(), {
    message: "Phone number is invalid",
  });
